import { 
    IMutations, 
} from './mutations.types'
import { IvalidationData} from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants'

export const mutations: IMutations = {

    /** set the selected application */
    setValidationData(state: IvalidationData, payload: any): void {
        state.validationMessages = payload.data;       
    },
}
